import types from './types';

const INITIAL_STATE = {
    exportsInfo: {
        pendingExports: [],
        runningExports: [],
        completedExports: []
    },
    loading: false
};

const exportsQueuePageReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.SET_EXPORTS_INFO:
            return { ...state, exportsInfo: action.payload };
        case types.SET_LOADING:
            return { ...state, loading: action.payload };
        default:
            return state;
    }
};

export default exportsQueuePageReducer;
